export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-lightbox/index.js